import {createSlice} from "@reduxjs/toolkit";
import {changeRegion, LoadingState} from "@ots-frontend/ots-data";
import {LocationHistoryMapFilter} from "../../../model/location-history";
import { MapState } from "../../../components/map/Map/Map";
import {setLocationHistoryMapDate, setLocationHistoryMapFilter, setLocationHistoryMapState} from "./actions";

type State = {
  mapState?: MapState
  filter: LocationHistoryMapFilter
  minimumIncrementerDttm?: number;
  maximumIncrementerDttm?: number;
  dttm?: number;
  loading: LoadingState
  error?: string
}

const INITIAL_STATE: Readonly<State> = {
  mapState: undefined,
  filter: {
    showSites: false,
    showDriverLocations: false,
    showDriverLocationRoute: false,
    showGeofenceEvents: true,
    showTransportRoutes: true,
    selectedShiftId: undefined,
    selectedTransportIds: [],
  },
  minimumIncrementerDttm: undefined,
  maximumIncrementerDttm: undefined,
  dttm: undefined,
  error: undefined,
  loading: 'idle'
};

const mapSlice = createSlice({
  name: "map",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setLocationHistoryMapState,
      (state, {payload}) => {
        state.mapState = payload;
      }
    );
    builder.addCase(
      setLocationHistoryMapFilter,
      (state, {payload}) => {
        state.filter = payload;
      }
    );
    builder.addCase(
      setLocationHistoryMapDate,
      (state, {payload}) => {
        state.dttm = payload;
      }
    );
    builder.addCase(changeRegion, (_state) => {
      return INITIAL_STATE;
    });
  }
});

export const locationHistoryMapReducer = mapSlice.reducer;
